<template>
  <div class="contents">
    <div class="d-flex section-title-with-back">
      <img src="@/assets/images/Icon awesome-pen.png" alt width="27.3" height="27.3" />
      <p class="title-bk">教場編集</p>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <router-link :to="{ name: id ? 'school-id-detail' : 'school-detail', params: id ? { id } : {} }">
        戻る
      </router-link>
    </div>
    <div class="container">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(confirmChanged)" ref="form">
          <table class="table table-form">
            <tbody>
              <tr>
                <th scope="row">法人名（法人ID）</th>
                <td />
                <td>{{ currentCorporationDisplay }}</td>
              </tr>
              <tr>
                <th scope="row">ブランド名（ブランドID）</th>
                <td />
                <td>{{ currentBrandDisplay }}</td>
              </tr>
              <tr>
                <th scope="row">教場名（教場ID）</th>
                <td />
                <td>{{ currentSchoolDisplay }}</td>
              </tr>
              <PasswordField vid="password" v-model="password" extraRules="required" />
              <PasswordField
                v-model="verifyPassword"
                extraRules="required|verify_password:password"
                label="パスワード（確認）"
              />
            </tbody>
          </table>
          <div class="text-center">
            <button type="submit" class="btn-red">実行</button>
          </div>
        </form>
      </ValidationObserver>
      <PopUpHolder
        ref="popup_holder"
        no-close-on-esc
        no-close-on-backdrop
        green-button-title="教場情報に戻る"
        @greenClick="popupConfirmed"
      >
        <template v-slot:header>教場情報</template>
        <template v-slot:body>パスワードの変更が完了しました</template>
      </PopUpHolder>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import store from '@/store/index.js';
import PopUpHolder from '@/components/popups/PopUpHolder.vue';
import { ValidationObserver } from 'vee-validate';
import PasswordField from '@/components/forms/PasswordField.vue';
import { basicCorporationNameIdPresent, basicBrandNameIdPresent, basicSchoolNameIdPresent } from '@/presenters/fields';

export default {
  props: {
    id: {
      type: [String, Number],
      required: false,
    },
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    if (routeTo.params.id) {
      store.dispatch('school/fetchSchool', routeTo.params.id).then(() => {
        next();
      });
    } else {
      next();
    }
  },
  components: {
    ValidationObserver,
    PasswordField,
    PopUpHolder,
  },
  data() {
    return {
      password: '',
      verifyPassword: '',
    };
  },
  computed: {
    currentSchool() {
      return this.school.school;
    },
    currentCorporationDisplay() {
      return basicCorporationNameIdPresent(this.currentSchool.corporation);
    },
    currentBrandDisplay() {
      return basicBrandNameIdPresent(this.currentSchool.brand);
    },
    currentSchoolDisplay() {
      return basicSchoolNameIdPresent(this.currentSchool);
    },
    ...mapState(['school']),
  },
  methods: {
    confirmChanged() {
      let payload = {
        id: this.currentSchool.id,
        password: this.password,
      };
      this.changeSchoolPassword(payload).then(() => {
        this.$logger.debug('Show success popup');
        this.$refs['popup_holder'].show();
      });
    },
    popupConfirmed() {
      this.$logger.debug('Popup done');
      if (this.id) {
        // This path is for TIE, Corporation and Brand Role
        this.$logger.debug('Password Changed for ID: ' + this.id);
        this.$router.push({ name: 'school-id-detail', params: { id: this.id } });
      } else {
        // This path is for School Role
        this.$logger.debug('Password Changed');
        this.$router.push({ name: 'school-detail' });
      }
    },
    ...mapActions('school', ['changeSchoolPassword']),
  },
};
</script>

<style scoped>
.btn-red {
  margin-left: 0px;
}
.line-break {
  width: 100%;
}
</style>
